module.exports = __webpack_public_path__ + "img/chris_g_ed.cb0eef42.jpg";